import apiProcess from "../../../api/utility";
import { getD2DChannelList, createD2DChannel, deleteD2DChannel, getD2DChannelContent, updateD2DChannelContent, simulationD2D, getD2DLog, renameD2DChannel } from "../../../api/Rocky/d2d";

function getD2DChannelListPromise(projectId) {
  return apiProcess(getD2DChannelList, projectId)
}

function createD2DChannelPromise({ name, projectId, content }) {
  return apiProcess(createD2DChannel, { name, projectId, content })
}

function deleteD2DChannelPromise(d2dChannelIds) {
  return apiProcess(deleteD2DChannel, { d2dChannelIds })
}

function getD2DChannelContentPromise(d2dChannelId) {
  return apiProcess(getD2DChannelContent, d2dChannelId)
}

function updateD2DChannelContentPromise({ d2dChannelId, content }) {
  return apiProcess(updateD2DChannelContent, { d2dChannelId, content })
}

function simulationD2DPromise({ d2dChannelId, options }) {
  return apiProcess(simulationD2D, { d2dChannelId, options })
}

function getD2DLogPromise(verificationId) {
  return apiProcess(getD2DLog, verificationId, false, false, true)
}

function renameD2DChannelPromise({ d2dChannelId, name }) {
  return apiProcess(renameD2DChannel, { d2dChannelId, name })
}

export {
  getD2DChannelListPromise,
  createD2DChannelPromise,
  deleteD2DChannelPromise,
  getD2DChannelContentPromise,
  updateD2DChannelContentPromise,
  simulationD2DPromise,
  getD2DLogPromise,
  renameD2DChannelPromise
}